
// ********* Import CSS ***************** //
import '@styles/main.scss';
import "./previous-camps-classes.css";

// ********* Import Images ***************** //

// ** HTML Bracket Images ** //
import "/src/assets/icons/white-brackets.png";

// ** Camp Flyer ** //
import "/src/assets/flyers/girls-code-sav-summer-camp-2023-flyer.png";

// ** Sponsors ** //
import "/src/assets/sponsor-logos/business-innovation-group.jpg";
import "/src/assets/sponsor-logos/city-of-savannah.png";
import "/src/assets/sponsor-logos/city-of-savannah-white.png";
import "/src/assets/sponsor-logos/fly-corps.png";
import "/src/assets/sponsor-logos/howmet-aerospace.png";
import "/src/assets/sponsor-logos/howmet-womens-network.png";
import "/src/assets/sponsor-logos/sams-club-blue-bkgnd.png";
import "/src/assets/sponsor-logos/live-oak-public-libraries.png";
import "/src/assets/sponsor-logos/bud-johnson-photography.png";

// ** GSU Photos ** //
import "/src/assets/summer-camp-2023/girls-walking-gsu-campus.jpg";
import "/src/assets/summer-camp-2023/gsu-campus.jpg";
import "/src/assets/summer-camp-2023/gsu-comp-sci-lab.jpg";
import "/src/assets/summer-camp-2023/gsu-science-center.jpg";
import "/src/assets/summer-camp-2023/girls-lunch-galley.jpg";

// ** Icebreakers ** //
import "/src/assets/summer-camp-2023/girls-playing-jenga.jpg";
import "/src/assets/summer-camp-2023/binary-bracelet.jpg";
import "/src/assets/summer-camp-2023/holding-binary-bracelet.jpg";
import "/src/assets/summer-camp-2023/girls-playing-spaghetti.jpg";

// ** Web Development ** //
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-15.jpeg";
import "/src/assets/summer-camp-2023/lesli-teaching.jpg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-21.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-7.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-web-dev-1.jpg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-web-dev-2.jpg";

// ** Fly Corps 1st Set ** //
import "/src/assets/summer-camp-2023/fly-corps-first-flight-board.jpg";
import "/src/assets/summer-camp-2023/fly-corps-plane-coming-in.jpg";
import "/src/assets/summer-camp-2023/fly-corps-girls-by-painting.jpg";

// ** Fly Corps 2nd Set ** //
import "/src/assets/summer-camp-2023/fly-corps-jake-talking-to-girls.jpg";
import "/src/assets/summer-camp-2023/fly-corps-app-screen.jpg";
import "/src/assets/summer-camp-2023/fly-corps-diya-laurie.png";

// ** Fly Corps 3rd Set ** //
import "/src/assets/summer-camp-2023/fly-corps-on-plane.jpg";
import "/src/assets/summer-camp-2023/fly-corps-in-plane-1.jpg";
import "/src/assets/summer-camp-2023/fly-corps-in-plane-2.jpg";
import "/src/assets/summer-camp-2023/fly-corps-in-plane-3.jpg";
import "/src/assets/summer-camp-2023/fly-corps-girls-in-line-plane.jpg";
import "/src/assets/summer-camp-2023/fly-corps-laurie-showing-plane.jpg";

// ** Girls Code Savannah & Creative Coast Team ** //
import "/src/assets/summer-camp-2023/lesli-with-girls.jpeg";
import "/src/assets/summer-camp-2023/jen-kait.jpeg";
import "/src/assets/summer-camp-2023/gcs-instructors.png";

// ** Camp Showcase ** //

import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-1.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-2.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-3.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-4.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-5.jpeg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-6.jpeg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-7.jpeg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-8.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-showcase-9.jpg";

// ** SUMMER CAMP 2023 - Camp Sponsors ** //
// import "/src/assets/sponsor-logos/business-innovation-group.jpg";
// import "/src/assets/sponsor-logos/city-of-savannah.png";
// import "/src/assets/sponsor-logos/fly-corps.png";
// import "/src/assets/sponsor-logos/howmet-aerospace.png";
// import "/src/assets/sponsor-logos/howmet-womens-network.png";
// import "/src/assets/sponsor-logos/sams-club-blue-bkgnd.png";

// ** Friends ** //

import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-friends-1.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-friends-2.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-friends-3.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-friends-4.jpeg";
import "/src/assets/summer-camp-2023/gcs-summer-camp-2023-friends-5.jpg";
import "/src/assets/summer-camp-2023/summer-camp-2023-group-photo.jpg";


// ** FALL SESSIONS 2023 - Photos for Carousel ** //
// import "/src/assets/fall-sessions-2023/3-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/4-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/6-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/7-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/9-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/10-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/21-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/37-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/71-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/82-girlscode-BJP-fall-2023.jpg";
// import "/src/assets/fall-sessions-2023/89-girlscode-BJP-fall-2023.jpg";

// ** SUMMER CAMP 2023 - Themed Photos for Gallery ** //
// import "/src/assets/themed-photos/airplane-controls.jpg";
// import "/src/assets/themed-photos/amelia.jpg";
// import "/src/assets/themed-photos/bessie-coleman.jpg";
// import "/src/assets/themed-photos/airplane.jpg";
// import "/src/assets/sponsor-logos/fly-corps-off-white-bkgnd.png";

// ** SUMMER CAMP 2023 - Computer Screen ** //
import "/src/assets/themed-photos/html-button.png";
import "/src/assets/themed-photos/css-button.png";
import "/src/assets/themed-photos/hello-world-computer-screen.png";

// ********* Add Top Nav & Footer *************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add JS for Email Signup & Error Popup *************** //

import '/src/nav-header-footer/email-contact-new-classes.js';

// **************************** Add SS2025 Feature ************************** //

import '/src/homepage-features/8-ss2025-feature/ss2025-feature.js';

// **************************** Add WC2024 Feature ************************** //

import '/src/homepage-features/7-wc2024-feature/wc2024-feature.js';

// **************************** Add FS2024 Feature ************************** //

import '/src/homepage-features/6-fs2024-feature/fs2024-feature.js';

// **************************** Add SC2024 Feature ************************** //

import '/src/homepage-features/5-sc2024-feature/sc2024-feature.js';

// **************************** Add SS2024 Feature ************************** //

import '/src/homepage-features/4-ss2024-feature/ss2024-feature.js';

// **************************** Add WC2023 Feature ************************** //

import '/src/homepage-features/3-wc2023-feature/wc2023-feature.js';


// **************************** Loading Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("preloader").style.display = "block";
  setTimeout(removeLoadingSpinner, 1000);
});

function removeLoadingSpinner(){
  $( "#preloader" ).fadeOut(100, function() {
    $( "#preloader" ).remove();
  });
}

